module.exports = __webpack_public_path__ + "static/media/sample-golfer.97a71f8b.png";